"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFactory = void 0;
const uuid_1 = require("uuid");
const FailedRecord_1 = require("../storyblocks/common/FailedRecord");
const Meta_1 = require("../storyblocks/common/Meta");
class EventFactory {
    static meta(origin, trace) {
        const meta = new Meta_1.Meta;
        meta.uuid = (0, uuid_1.v4)();
        meta.emitted = Date.now();
        meta.origin = origin;
        meta.trace = trace;
        return meta;
    }
    static failedRecord(record, topic, origin, details, trace) {
        const failedRecord = new FailedRecord_1.FailedRecord();
        failedRecord.meta = EventFactory.meta(origin, trace);
        failedRecord.payload = JSON.stringify(record);
        failedRecord.topic = topic;
        if (details)
            failedRecord.details = details;
        return failedRecord;
    }
}
exports.EventFactory = EventFactory;
//# sourceMappingURL=EventFactory.js.map